import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import PortfolioCard from "./PortfolioCard";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";
// const gitHubQuery = "/repos?sort=updated&direction=desc";
// const specficQuerry = "https://api.github.com/repos/hashirshoaeb/";

const Portfolio = ({ isDarkMode }) => {
  const portfolioArr = [
    {
      Name: "African Proverbs",
      imageLink1: require("../../editable-stuff/portfolio/africanProverbs.png"),
      imageLink2: require("../../editable-stuff/portfolio/africanProverbs2.png"),
      imageSize: 250,
      about:
        "African Proverbs is a website that helps in the facilitation African proverbs as a means of educatication and communication.",
      link: "https://africanproverbs.com/",
    },
    {
      Name: "Plug .IO",
      imageLink1: require("../../editable-stuff/portfolio/plug.png"),
      imageLink2: require("../../editable-stuff/portfolio/plug2.png"),
      imageSize: 250,
      about:
        "Plug .io is a no code web app that helps in the Transformation and automations of businesses ",
      link: "https://www.plugonline.io/",
    },
    {
      Name: "Post paddy",
      imageLink1: require("../../editable-stuff/portfolio/postPaddy.png"),
      imageLink2: require("../../editable-stuff/portfolio/postPaddy2.png"),
      imageSize: 250,
      about:
        "Post paddy is a social media app that helps in monitoring audience growth, and drive engagement ",
      link: "https://postpaddy.com/",
    },
    {
      Name: "Ecscorp",
      imageLink1: require("../../editable-stuff/portfolio/escorp.png"),
      imageLink2: require("../../editable-stuff/portfolio/escorp2.png"),
      imageSize: 250,
      about:
        "Ecscorp is a website for a business that helps in building and management of other businesses.",
      link: "https://ecscl.com/",
    },
    {
      Name: "Farst Cart",
      imageLink1: require("../../editable-stuff/portfolio/farstCart.png"),
      imageLink2: require("../../editable-stuff/portfolio/farstCart2.png"),
      imageSize: 250,
      about:
        "Farst Cart is an ecommerce website where customers can shop for groceries online and have the delivered to their doorstep.",
      link: "https://www.farstcart.com/",
    },
    {
      Name: "Koko Health",
      imageLink1: require("../../editable-stuff/portfolio/kokoHealthCare.png"),
      imageLink2: require("../../editable-stuff/portfolio/kokoHealthCare2.png"),
      imageSize: 250,
      about:
        "Farst Cart is an health care management software that helps automate the daily operations in an healthcare organisation.",
      link: "https://kokopatient.calmglobal.com/",
    },
  ];

  //const [portfolioArr, setPortfolioArr] = useState([]);

  return (
    <Container
      fluid
      id="projects"
      className={`${
        isDarkMode ? "background-theme-darker" : "bg-light"
      } m-0 py-4`}
    >
      {portfolioArr.length ? (
        <Container className="pt-4">
          <h2
            className={`${
              isDarkMode ? "color_yellow" : ""
            } display-4 pb-5  text-center`}
          >
            Portfolio
          </h2>
          <Row>
            {portfolioArr?.map((portfolio, index) => (
              <PortfolioCard
                key={`portfolio-card-${index}`}
                id={`portfolio-card-${index}`}
                value={portfolio}
                isDarkMode={isDarkMode}
              />
            ))}
          </Row>
        </Container>
      ) : (
        ""
      )}
    </Container>
  );
};

export default Portfolio;
